import { isNotDefined } from '@sgme/fp';
import type { ICellRendererParams } from 'ag-grid-community';
import classNames from 'classnames';
import { FC } from 'react';

export const ColoredNumberCellRenderer: FC<ICellRendererParams<unknown, number>> = ({ value }) => {
  if (isNotDefined(value)) {
    return null;
  }

  return (
    <span
      className={classNames('tabular-figures text-large', {
        'text-success': value > 0,
        'text-danger': value < 0,
        'text-secondary': value === 0,
      })}
    >
      {value}
    </span>
  );
};
